<ng-container *ngIf="mode === 'view'">
  <app-label [label]="name">
    <div class="value__wrapper">
      <tui-tag
        *ngIf="committee$ | async as committee; else empty"
        class="value"
        [routerLink]="'/committees/' + committee.id"
        [value]="committee.name || ''"
        [hoverable]="true"
      ></tui-tag>
    </div>
  </app-label>
</ng-container>

<div *ngIf="mode === 'preview'">
  <app-link
    *ngIf="committee$ | async as committee; else empty"
    [iconEnd]="'@tui.mail'"
    [routerLink]="'/committees/' + committee.id"
    [pseudo]="true"
    [displayText]="committee.name"
  ></app-link>
</div>

<ng-template #empty>
  <div class="tui-skeleton tui-skeleton_text empty">&nbsp;</div>
</ng-template>
